import React from 'react';
import { productActionsMap } from '../utils/productHelper.mjs';
import Product from './Product.jsx';

const ProductList = ({ products, isCollapsibleListOpen = false, onShowContactModal, appointmentScheduled }) => {

  const renderedCart = Object.keys(productActionsMap).map((groupKey) => {
    const group = productActionsMap[groupKey];
    const filteredProducts = products.filter( (product) => {
      return group.includes( product.id );
    });

    return (group.length && filteredProducts.length)
      ? <div className={ `product-group ${ groupKey }` } key={ group.type }>
        { filteredProducts.map( (p) => <Product
          product={ p }
          key={ p.id }
          isCollapsibleListOpen={ isCollapsibleListOpen }
          onShowContactModal={ onShowContactModal }
          appointmentScheduled={ appointmentScheduled }
        />)
        }
      </div>
      : null;

  });

  return <>{ renderedCart }</>;
};

export default ProductList;
